import { render, staticRenderFns } from "./TwoUpStatic.vue?vue&type=template&id=431022eb&scoped=true&"
import script from "./TwoUpStatic.vue?vue&type=script&lang=js&"
export * from "./TwoUpStatic.vue?vue&type=script&lang=js&"
import style0 from "./TwoUpStatic.vue?vue&type=style&index=0&id=431022eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431022eb",
  null
  
)

export default component.exports